<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/broadcaster-channel" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.CreateChannel") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card title card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.ChannelName')"
              >
                <vs-input
                  :label="$t('setup.label.ChannelName')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="channel.channelName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold starlabel"
                  >{{ $t("setup.label.Language")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Language')"
                >
                  <v-select
                    label="name"
                    v-model="channel.language"
                    :options="channelTemplate.languageEnum"
                    :placeholder="$t('placeholder.label.SelectOne')"
                  >
                    <template v-slot:option="option">{{
                      option.name
                    }}</template></v-select
                  >
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="vx-col w-full" style="margin: 1rem 0">
                <vs-checkbox
                  class="mt-3 font-semibold starlabel"
                  v-model="channel.isLocalChannel"
                  >{{ $t("setup.label.IsLocalChannel") }}</vs-checkbox
                >
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="vx-col w-full" style="margin: 1rem 0">
                <vs-checkbox
                  class="mt-3 font-semibold"
                  v-model="channel.isHdChannel"
                  >{{ $t("setup.label.IsHdChannel") }}</vs-checkbox
                >
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required|numeric"
                v-slot="{ errors }"
                :name="$t('setup.label.ChannelSequence')"
              >
                <vs-input
                  :label="$t('setup.label.ChannelSequence')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="channel.channelSequence"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.Genre")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Genre')"
                >
                  <v-select
                    v-model="channel.channelCategory"
                    :options="channelCategorys"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(option) => option.value"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.ChannelType")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ChannelType')"
                >
                  <v-select
                    label="name"
                    v-model="channel.channelType"
                    :options="channelTypes"
                    :placeholder="$t('placeholder.label.SelectOne')"
                  >
                    <template v-slot:option="option">{{
                      option.name
                    }}</template></v-select
                  >
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.BroadcasterId")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.BroadcasterId')"
                >
                  <v-select
                    label="broadcasterName"
                    v-model="channel.broadcasterId"
                    :options="channelTemplate.broadcasterDatas"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(name) => name.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.broadcasterName
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("setup.label.Reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createchannel"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import Vue from "vue";
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ValidationPopupVue from "@/components/ValidationPopup.vue";
Vue.component("v-select", vSelect);

const channelEmptyObj = {
  isHdChannel: false,
  broadcasterId: "",
  channelName: "",
  broadcasterName: "",
  channelCategory: "",
  channelSequence: "",
  channelType: "",
  isLocalChannel: false,
  language: "",
};
// const broadcastSelectData = { label: "", id: "" };
export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      channel: channelEmptyObj,
      channelTypes: ["Pay", "FTA"],
      broadcasters: [],
      channelCategorys: [],
      broadcast_: "",
      selected: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    "v-select": vSelect,
    "validation-popup": ValidationPopupVue,
  },
  computed: {
    ...mapState({
      channelTemplate: (state) => state.broadcaster.channelTemplate,
    }),
  },
  methods: {
    async getChannelTemplate() {
      try {
        await this.$store.dispatch("broadcaster/setChannelTemplate");
        let i = 0;
        for (let temp of this.channelTemplate.broadcasterDatas) {
          this.broadcasters = [...this.broadcasters, { label: "", value: "" }];
          this.broadcasters[i].value = temp.id;
          this.broadcasters[i].label = temp.broadcasterName;
          i += 1;
        }
        let j = 0;
        for (let temp of this.channelTemplate.channelCategorys) {
          this.channelCategorys = [
            ...this.channelCategorys,
            { label: "", value: "" },
          ];
          this.channelCategorys[j].value = temp.mCodeValue;
          this.channelCategorys[j].label = temp.mCodeValue;
          j += 1;
        }
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async createchannel() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      this.errorMessage = "";
      this.warningText = "";

      try {
        await this.$store.dispatch(
          "broadcaster/createChannelAction",
          this.channel
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Channel Created Successfully!",
          type: "success",
        });
        this.$router.push(`/setup/broadcaster-channel`);
        this.resetForm();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    cancel() {
      this.$router.push(`/setup/broadcaster-channel`);
    },
    resetForm() {
      this.channel = channelEmptyObj;
      this.channel = {
        isHdChannel: false,
        broadcasterId: "",
        channelName: "",
        broadcasterName: "",
        channelCategory: "",
        channelSequence: "",
        channelType: "",
        isLocalChannel: false,
        language: "",
      };
      if (this.$refs.observer) {
        this.$refs.observer.reset(); 
      }
    },
  },
  mounted() {
    this.resetForm();
    this.getChannelTemplate();
  },
};
</script>
